<template>
  <div class="menu-box">
    <el-menu
      :default-active="this.$route.path.split('#')[0]"
      class="el-menu-vertical-demo"
      background-color="transparent"
      :unique-opened="true"
      text-color="#a6c8ff"
      active-text-color="#fff" router>
      <div v-for="(item,index) in routerArr" :key="index">
        <el-menu-item v-if="item.children.length==0" :index='item.path'>
          <!-- <i class="iconfont icon-jiashicang"></i> -->
          <span slot="title">{{item.name}}</span>
        </el-menu-item>
        <el-submenu v-if="item.children.length>0" :index="item.path">
          <template slot="title">
            <span>{{item.name}}</span>
          </template>
          <el-menu-item-group>
            <el-menu-item v-for="(itemChild,indexChild) in item.children" :key="indexChild" :index='item.path+itemChild.path'>{{itemChild.name}}</el-menu-item>
          </el-menu-item-group>
        </el-submenu>
      </div>
    </el-menu>
    <div class="footer">
      <a href="http://www.beian.miit.gov.cn" target="_black">京ICP备18044594号-1&nbsp;&nbsp;&nbsp;版权所有©北京道口金科科技有限公司</a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Aside',
  data () {
    return {
      userInfo:JSON.parse(localStorage.getItem('UserInfo')),
      dkjkArr:[
        {
          name:'数据总览',
          path:'/sjzl',
          children:[]
        },
        {
          name:'用户管理',
          path:'/yhgl',
          children:[]
        },{
          name:'计费管理',
          path:'/jfgl',
          children:[]
        },{
          name:'权限分配',
          path:'/qxfp',
          children:[]
        },{
          name:'数据服务管理',
          path:'/',
          children:[]
        },{
          name:'系统设置',
          path:'/xtsz',
          children:[]
        }
      ],
      qdArr:[
        {
          name:'数据总览',
          path:'/sjzl',
          children:[]
        },
        {
          name:'用户管理',
          path:'/yhgl',
          children:[]
        },{
          name:'计费管理',
          path:'/jfgl',
          children:[]
        },{
          name:'权限分配',
          path:'/qxfp',
          children:[]
        },{
          name:'数据服务管理',
          path:'/',
          children:[]
        },{
          name:'系统设置',
          path:'/xtsz',
          children:[]
        }
      ],
      khArr:[
        {
          name:'数据总览',
          path:'/sjzl',
          children:[]
        },
        {
          name:'用户管理',
          path:'/yhgl',
          children:[]
        },{
          name:'计费管理',
          path:'/jfgl',
          children:[]
        },{
          name:'数据服务管理',
          path:'/',
          children:[]
        }
      ],
      routerArr:[]
    }
  },
  mounted(){
    var _this=this;
    if(_this.userInfo.comType==1){
      _this.routerArr=_this.dkjkArr;
    }else if(_this.userInfo.comType==2){
      _this.routerArr=_this.qdArr;
    }else if(_this.userInfo.comType==3){
      _this.routerArr=_this.khArr;
    };
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.menu-box,.el-menu{height: 100%;}
.menu-box{position: relative;}
.footer{position: absolute;left: 0%;bottom: 20px;}
.footer a{display: block;width: 90%;margin: 0 auto; font-size: 12px;color: #fff;line-height: 20px;}
</style>



// WEBPACK FOOTER //
// src/components/pageComponents/Aside.vue